import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./contentCard.html";
class ContentCard extends LightningElement {
  constructor(...args) {
    super(...args);
    this.badgeText = void 0;
    this.cardExcerpt = void 0;
    this.cardImage = void 0;
    this.cardLink = void 0;
    this.cardTarget = void 0;
    this.cardTitle = void 0;
    this.tagLink = void 0;
    this.tagText = void 0;
  }
  get hasImage() {
    return this.cardImage?.length > 0;
  }
  get hasLink() {
    return this.cardLink?.length > 0;
  }
  get hasExcerpt() {
    return this.cardExcerpt?.length > 0;
  }
  get hasTag() {
    return this.tagText?.length > 0;
  }
  get hasBadge() {
    return this.badgeText?.length > 0;
  }
  get badgeLabel() {
    return `${this.badgeText} min read`;
  }
  get cardLinkAttr() {
    return this.hasLink ? this.cardLink : '#';
  }
  get cardTargetAttr() {
    const validTargets = ['_blank', '_self', '_parent', '_top'];
    return validTargets.includes(this.cardTarget) ? this.cardTarget : '_self';
  }
  get validTagLink() {
    // A link (local or external) was supplied, use it.
    if (this.tagLink.includes('/')) {
      return this.tagLink;
    }

    // If tag-link was supplied without a valid URL,
    // Assume it's a content type slug and build a link.
    if (this.tagLink?.length > 0) {
      const slug = encodeURIComponent(this.tagLink);
      return `/learn?contentType=${slug}`;
    }

    // If neither tag-link nor tag-text were supplied, return a hash.
    return '#';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ContentCard, {
  publicProps: {
    badgeText: {
      config: 0
    },
    cardExcerpt: {
      config: 0
    },
    cardImage: {
      config: 0
    },
    cardLink: {
      config: 0
    },
    cardTarget: {
      config: 0
    },
    cardTitle: {
      config: 0
    },
    tagLink: {
      config: 0
    },
    tagText: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ContentCard, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;